import styled from 'styled-components';
import { LabelRegularBoldM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const ReportInsightsCont = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mega} 0 0 0;
  `}
`;

export const ResultTableTitle = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 17px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `}
`;

export const NoDataInfoCont = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
       padding: ${theme.layout.spacing.mega} 0;
       color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const NoDataInfo = styled(LabelRegularBoldM)`
  text-transform: uppercase;
  letter-spacing: 0.08em;
  ${({ theme }: IThemeProvider) => `
       color: ${theme.colors.neutral.primary[80]};
  `};
`;
